import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Flex } from '@haldor/ui';
import { archiveConversation, clearSearch, getArchivedConversations, getConversations, searchConversation, stageConversation } from 'actions/conversation';
import Redirect from 'components/Redirect/Redirect';
import Modal from 'containers/Modals/Modal';
import Moment from 'moment';
import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import swal from 'sweetalert2';
import { Collapsible, Person } from 'UI';
import { Search } from 'UI/Inputs';
import { Icon, Button } from '@haldor/ui';
import LoadingCards from 'components/Cards/LoadingCard';
import User from '_class/User';
import '../Conversation.scss';
import SelectRecipientForm from '../Form/SelectRecipient';
import { getConversationParticipants } from '../Helpers';
import { setPageTitle, setPageActions } from 'actions/header';

var ConversationsPage = /*#__PURE__*/function (_Component) {
  _inherits(ConversationsPage, _Component);

  var _super = _createSuper(ConversationsPage);

  /* Class setup */
  function ConversationsPage(props) {
    var _this;

    _classCallCheck(this, ConversationsPage);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillMount", function () {
      _this.setState({
        loading: true
      });

      _this.props.getConversations().then(function () {
        _this.setState({
          loading: false
        });
      });

      _this.props.setPageTitle(_this.props.translate('messages'));

      _this.props.setPageActions([{
        value: _this.props.translate('write-new'),
        onClick: _this.toggleModal,
        type: 'button'
      }]);
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this.props.clearSearch();
    });

    _defineProperty(_assertThisInitialized(_this), "toggleModal", function () {
      _this.setState({
        modal: !_this.state.modal
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSelectRecipients", function (values) {
      return new Promise(function () {
        // Create conversation API request hereee
        var conversation = {
          title: '',
          status: 'ACTIVE',
          memberships: values.memberships,
          messages: [],
          relationships: values.relationships,
          id: 'new'
        };

        _this.props.stageConversation(conversation).then(function () {
          _this.setState({
            modal: false
          });

          _this.props.history.push("/conversations/new");
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSearch", function (query) {
      if (query.query.length == 0) {
        _this.props.clearSearch();

        _this.setState({
          searchView: false
        });

        _this.props.setPageTitle(_this.props.translate('conversations'));

        return;
      }

      if (query.query.length < 2) {
        return;
      }

      _this.setState({
        searching: true,
        searchView: true
      });

      _this.props.searchConversation(query.query).then(function () {
        _this.props.setPageTitle(_this.props.translate('search-result'));

        _this.setState({
          searching: false
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "archiveConversation", function (event, conversation) {
      event.preventDefault();
      event.stopPropagation();

      if (conversation == null) {
        return;
      }

      swal.fire({
        title: _this.props.translate('are-you-sure'),
        text: _this.props.translate('conversation-archive-message'),
        showCancelButton: true,
        cancelButtonText: _this.props.translate('Cancel'),
        confirmButtonText: _this.props.translate('Remove')
      }).then(function (response) {
        if (response.value != null) {
          _this.props.archiveConversation(conversation);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderConversation", function (conversation, index) {
      var participants = getConversationParticipants(conversation, _this.props.user);
      var user = new User(_this.props.user);
      var message = null;

      if (conversation.messages.length > 0 && conversation.messages[conversation.messages.length - 1] != null) {
        var lastMessage = conversation.messages[conversation.messages.length - 1];

        if (lastMessage.flagID != null) {
          message = /*#__PURE__*/React.createElement("span", {
            style: {
              fontStyle: 'italic'
            }
          }, _this.props.translate('Message is reported as inappropriate.'));
        } else {
          message = lastMessage.text.replace(/(<([^>]+)>)/ig, '');

          if (message.length > 155) {
            message = message.substring(0, 155) + '...';
          }
        }
      }

      return /*#__PURE__*/React.createElement(Link, {
        key: 'conversation' + index,
        to: "/conversations/".concat(conversation.id),
        className: "conversation-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "participants"
      }, /*#__PURE__*/React.createElement("div", null, participants.map(function (participant, index) {
        if (participant.membershipType == 'SECTION_OWNERS') {
          return /*#__PURE__*/React.createElement(Person, {
            person: _objectSpread({
              firstName: participant.title,
              lastName: ''
            }, participant),
            key: participant.id
          });
        }

        if (participant != null) {
          if (participant.membershipType == 'GUARDIAN') {
            participant.lastName = (participant.lastName != null ? participant.lastName : '') + ' (' + _this.props.translate('Guardian') + ')';
          }

          return /*#__PURE__*/React.createElement(Person, {
            person: participant,
            key: 'person-' + index + '-' + participant.userId
          });
        }
      })), conversation.status.toUpperCase() == 'ACTIVE' && !user.isStudent() ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
        onClick: function onClick(e) {
          return _this.archiveConversation(e, conversation);
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Bin"
      }))) : null), /*#__PURE__*/React.createElement("div", {
        className: "latest-message"
      }, conversation.unreadMessages > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "unread-badge"
      }) : null, message != null ? message : null));
    });

    _this.state = {
      modal: false,
      searching: false,
      searchView: false,
      loading: false,
      loadingArchievedConversation: false
    };
    return _this;
  }
  /* Lifecycle events */


  _createClass(ConversationsPage, [{
    key: "toggleOpen",
    value: function () {
      var _toggleOpen = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.props.archived == null)) {
                  _context.next = 5;
                  break;
                }

                this.setState({
                  loadingArchievedConversation: true
                });
                _context.next = 4;
                return this.props.getArchivedConversations();

              case 4:
                this.setState({
                  loadingArchievedConversation: false
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function toggleOpen() {
        return _toggleOpen.apply(this, arguments);
      }

      return toggleOpen;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      if (!this.props.services.conversations) {
        return /*#__PURE__*/React.createElement(Redirect, {
          to: "/"
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "section",
        style: {
          padding: 0,
          margin: 0,
          border: 0
        }
      }, /*#__PURE__*/React.createElement(Modal, {
        onClose: this.toggleModal,
        overridePrompt: true,
        title: this.props.translate('new-message'),
        isOpen: this.state.modal,
        type: "small"
      }, /*#__PURE__*/React.createElement(SelectRecipientForm, {
        onSubmit: this.onSelectRecipients
      })), /*#__PURE__*/React.createElement("div", {
        className: "overview"
      }, /*#__PURE__*/React.createElement("div", {
        className: "conversation conversation--wrapper"
      }, /*#__PURE__*/React.createElement("div", {
        className: "conversation-list"
      }, /*#__PURE__*/React.createElement(Flex, {
        center: true,
        space: true
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          flex: '1'
        }
      }, /*#__PURE__*/React.createElement(Search, {
        onSubmit: this.onSearch,
        loading: this.state.searching,
        placeholder: this.props.translate('search-for-conversation'),
        autoSearch: true,
        allowEmpty: true
      }))), this.state.loading ? /*#__PURE__*/React.createElement(LoadingCards, {
        count: 1
      }) : this.props.results != null && this.state.searchView ? this.props.results.map(function (conversation, index) {
        return _this2.renderConversation(conversation, index);
      }) : this.props.conversations != null ? this.props.conversations.map(function (conversation, index) {
        return _this2.renderConversation(conversation, index);
      }) : null, /*#__PURE__*/React.createElement("div", {
        className: "archived-conversations"
      }, /*#__PURE__*/React.createElement(Collapsible, {
        onChange: function onChange(open) {
          return _this2.toggleOpen();
        },
        trigger: this.props.translate('Removed')
      }, this.state.loadingArchievedConversation ? /*#__PURE__*/React.createElement(LoadingCards, {
        count: 1
      }) : null, !this.state.loadingArchievedConversation && this.props.archived != null && this.props.archived.length > 0 ? /*#__PURE__*/React.createElement("div", null, this.props.archived.map(function (conversation, index) {
        return _this2.renderConversation(conversation, index);
      })) : null))))));
    }
  }]);

  return ConversationsPage;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    user: state.user.currentUser,
    conversations: state.Conversation.conversations,
    archived: state.Conversation.archived,
    results: state.Conversation.searchResults,
    services: state.Services.availableServices
  };
}

export default withRouter(connect(mapStateToProps, {
  getConversations: getConversations,
  stageConversation: stageConversation,
  searchConversation: searchConversation,
  clearSearch: clearSearch,
  archiveConversation: archiveConversation,
  getArchivedConversations: getArchivedConversations,
  setPageTitle: setPageTitle,
  setPageActions: setPageActions
})(ConversationsPage));